import React, { useState, useEffect } from 'react';
import apiService from '../services/api';

const BackendTest = () => {
  const [statusResult, setStatusResult] = useState(null);
  const [userResult, setUserResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const testStatusEndpoint = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await apiService.checkStatus();
      setStatusResult(result);
      console.log('Status check result:', result);
    } catch (err) {
      setError(err.message);
      console.error('Status check error:', err);
    } finally {
      setLoading(false);
    }
  };

  const testUserEndpoint = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await apiService.getCurrentUser();
      setUserResult(result);
      console.log('User check result:', result);
    } catch (err) {
      setError(err.message);
      console.error('User check error:', err);
    } finally {
      setLoading(false);
    }
  };

  // Test status endpoint on component mount
  useEffect(() => {
    testStatusEndpoint();
  }, []);

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-6 text-rateiq-darkest-blue">Backend Connection Test</h2>
      
      {/* Status Test */}
      <div className="mb-6 p-4 border border-gray-200 rounded-lg">
        <h3 className="text-lg font-semibold mb-3">Status Endpoint Test</h3>
        <button
          onClick={testStatusEndpoint}
          disabled={loading}
          className="bg-rateiq-blue hover:bg-rateiq-dark-blue text-white px-4 py-2 rounded-lg disabled:opacity-50"
        >
          {loading ? 'Testing...' : 'Test /status'}
        </button>
        
        {statusResult && (
          <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded">
            <h4 className="font-semibold text-green-800">Success!</h4>
            <pre className="text-sm text-green-700 mt-1">
              {JSON.stringify(statusResult, null, 2)}
            </pre>
          </div>
        )}
      </div>

      {/* User Test */}
      <div className="mb-6 p-4 border border-gray-200 rounded-lg">
        <h3 className="text-lg font-semibold mb-3">User Endpoint Test</h3>
        <button
          onClick={testUserEndpoint}
          disabled={loading}
          className="bg-rateiq-blue hover:bg-rateiq-dark-blue text-white px-4 py-2 rounded-lg disabled:opacity-50"
        >
          {loading ? 'Testing...' : 'Test /whoami'}
        </button>
        
        {userResult && (
          <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded">
            <h4 className="font-semibold text-green-800">Success!</h4>
            <pre className="text-sm text-green-700 mt-1">
              {JSON.stringify(userResult, null, 2)}
            </pre>
          </div>
        )}
      </div>

      {/* Error Display */}
      {error && (
        <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
          <h4 className="font-semibold text-red-800">Error</h4>
          <p className="text-red-700 mt-1">{error}</p>
          <div className="mt-2 text-sm text-red-600">
            <p>Possible issues:</p>
            <ul className="list-disc list-inside ml-4">
              <li>Backend server is not running</li>
              <li>Backend URL is incorrect (check .env file)</li>
              <li>CORS is not configured properly</li>
              <li>Network connection issue</li>
            </ul>
          </div>
        </div>
      )}

      {/* Instructions */}
      <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <h4 className="font-semibold text-blue-800">Instructions:</h4>
        <div className="text-blue-700 mt-2 text-sm">
          <ol className="list-decimal list-inside space-y-1">
            <li>Make sure your backend server is running on port 8000</li>
            <li>Check the .env file has the correct REACT_APP_API_URL</li>
            <li>The /status endpoint should work without authentication</li>
            <li>The /whoami endpoint requires Firebase authentication</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default BackendTest; 